import { FC } from 'react';
import { Team } from '@frx/frx-services';
import {
  Avatar,
  Box,
  Button,
  HStack,
  Icon,
  Text,
  VStack,
} from '@chakra-ui/react';
import { useJoinTeam, useTeamPhoto } from '@frx/frx-react-context';
import { useEventId } from '../../../../hooks';
import { Plus } from '../../../../assets';
import styles from './TeamRecord.module.scss';
import { getDataTracking } from '../../../../utils';

export type TeamRecordProps = Partial<Team> & {
  onClose?: () => void;
};

export const TeamRecord: FC<TeamRecordProps> = (props) => {
  const {
    captainConsId,
    captainFirstName,
    captainLastName,
    companyName,
    id,
    name,
    onClose,
  } = props;
  const eventId = useEventId();
  const { data: teamPhoto } = useTeamPhoto({
    fr_id: eventId,
    cons_id: captainConsId,
  });
  const { mutate: joinTeam } = useJoinTeam();

  const handleJoinTeam = () => {
    joinTeam(
      {
        fr_id: eventId,
        team_id: id as number,
      },
      {
        onSuccess: () => {
          if (onClose) {
            onClose();
          }
        },
      }
    );
  };

  return (
    <HStack justify="space-between" className={styles.container}>
      <HStack minW="50%" maxW="75%">
        <Avatar src={teamPhoto?.customUrl} />
        <Box>
          <Text
            fontSize="20px"
            fontWeight="800"
            align="left"
            color="brand.additional.black"
          >
            {name}
          </Text>
          <Box pt={0.5}>
            <Text
              fontSize="md"
              fontWeight="semibold"
              color="brand.monochromatic.500"
            >
              {captainFirstName} {captainLastName}
            </Text>
            <Text
              fontSize="md"
              fontWeight="semibold"
              color="brand.monochromatic.500"
            >
              {companyName}
            </Text>
          </Box>
        </Box>
      </HStack>
      <Box>
        <Button
          onClick={handleJoinTeam}
          color="brand.primary.swatch1"
          variant="link"
          {...getDataTracking('joinTeamModalButton')}
        >
          <VStack>
            <Icon as={Plus} />
            <Text>Join Team</Text>
          </VStack>
        </Button>
      </Box>
    </HStack>
  );
};
